<!-- The text sits in its own span so the SCSS can limit click-to-focus to
     the visible words: the label element IS the grid column, and its bare
     regions used to focus the control from anywhere in the column. -->
<label
  [attr.for]="labelFor || null"
  [ngClass]="labelColClasses"
  [class.required]="required"
>
  <span *ngIf="label" class="form-row-label-text">{{ label | translate }}</span>
  <app-help-icon
    *ngIf="helpPageName"
    [helpPageName]="helpPageName"
  ></app-help-icon>
  <ng-content select="[label-extra]"></ng-content>
</label>

<div
  *ngIf="inputColClasses !== 'none'"
  class="form-row-input"
  [ngClass]="inputColClasses"
>
  <ng-content></ng-content>
</div>

<!-- Optional second label + control pair on the same row -->
<label
  *ngIf="label2"
  [attr.for]="label2For || null"
  [ngClass]="label2ColClasses"
  ><span class="form-row-label-text">{{ label2 | translate }}</span></label
>
<div *ngIf="label2" class="form-row-input" [ngClass]="input2ColClasses">
  <ng-content select="[second-control]"></ng-content>
</div>

<!-- Additional custom columns projected as direct row children -->
<ng-content select="[extra-col]"></ng-content>
